import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from './interfaces'
import type { ScopeStatus } from '@utils/stores/scoped-entry'

import { useDisciplineStore } from '@stores/discipline'

import { report } from '@utils/stores/progress-report/getters/report'
import { period } from '@utils/stores/progress-report/getters/period'
import { tutor } from '@utils/stores/progress-report/getters/tutor'
import { message } from '@utils/stores/progress-report/getters/message'
import { stats } from '@utils/stores/progress-report/getters/stats'
import { lessons } from '@utils/stores/progress-report/getters/lessons'
import { achievements } from '@utils/stores/progress-report/getters/achievements'
import { schedule } from '@utils/stores/progress-report/getters/schedule'
import { entryData, entryRevalidating, entryStatus } from '@utils/stores/scoped-entry'

const getActiveId = (): number | null => useDisciplineStore().activeDiscipline?.id ?? null

export const getters = {
  isLoading: (state: ProgressReportStore): boolean => {
    const id = getActiveId()
    return entryStatus(state.reportById, id) === 'loading' || entryStatus(state.listById, id) === 'loading'
  },
  isReportLoading: (state: ProgressReportStore): boolean => entryStatus(state.reportById, getActiveId()) === 'loading',
  isReportsLoading: (state: ProgressReportStore): boolean => entryStatus(state.listById, getActiveId()) === 'loading',
  getListStatus: (state: ProgressReportStore) => (id: number | null): ScopeStatus => entryStatus(state.listById, id),
  isListRevalidating: (state: ProgressReportStore) => (id: number | null): boolean => entryRevalidating(state.listById, id),
  getReportStatus: (state: ProgressReportStore) => (id: number | null): ScopeStatus => entryStatus(state.reportById, id),
  getReportById: (state: ProgressReportStore) => (id: number | null): ProgressReport | null => entryData(state.reportById, id),
  getReports: (state: ProgressReportStore): ProgressReport[] | null => entryData(state.listById, getActiveId()),
  isNewProgressReport: (state: ProgressReportStore): boolean => {
    const id = getActiveId()
    return id === null ? false : !!state.newById[id]
  },
  ...report,
  ...period,
  ...tutor,
  ...message,
  ...stats,
  ...lessons,
  ...achievements,
  ...schedule,
}
